<div class="google-callback-container">
  <div *ngIf="isLoading" style="text-align:center; padding:2rem;">
    <mat-spinner diameter="32"></mat-spinner>
    <p>{{ 'settings.google.oauth_processing' | translate }}</p>
  </div>
  <div *ngIf="errorMessage && !isLoading" class="alert alert-danger">
    <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
  </div>
  <div *ngIf="successMessage && !isLoading" class="alert alert-success">
    <i class="fas fa-check-circle"></i> {{ successMessage }}
  </div>
</div>

